import { apiRequest } from "./api";

export interface AuditEventInput {
  entityType: string;
  entityId: string;
  action: string;
  page: string;
  changes?: Record<string, { before?: unknown; after?: unknown }>;
  metadata?: Record<string, unknown>;
}

export interface AuditRecord extends AuditEventInput {
  auditId: string;
  businessId: string;
  actorId: string;
  actorName: string;
  timestamp: string;
}

export interface AuditHistoryPage {
  items: AuditRecord[];
  nextKey?: string;
}

export const auditApi = {
  /** Fire-and-forget from the caller — do not await if audit failure is non-critical. */
  log: (businessId: string, input: AuditEventInput): Promise<{ success: true }> =>
    apiRequest<{ success: true }>(`/biz/${businessId}/audit`, {
      method: "POST",
      body: input,
    }),

  getHistory: (
    businessId: string,
    entityType: string,
    entityId: string,
    cursor?: string,
  ): Promise<AuditHistoryPage> =>
    apiRequest<AuditHistoryPage>(
      `/biz/${businessId}/audit/${entityType}/${entityId}${cursor ? `?cursor=${cursor}` : ""}`,
    ),
};
